export default "__VITE_ASSET__TS02hgZ2__"